import React from "react";

export default props => (
  <ul
    className={"icons"}
    style={{
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    }}
  >
    <li>
      <img
        src="https://cdn.auth0.com/blog/react-js/react.png"
        alt="rails"
        className={"icon"}
      />
    </li>
    <li>
      <img
        src="https://cdn3.iconfinder.com/data/icons/popular-services-brands-vol-2/512/ruby-on-rails-512.png"
        alt="rails"
        className={"icon"}
      />
    </li>
    <li>
      <img
        src="https://w0.pngwave.com/png/884/748/postgresql-computer-icons-database-angularjs-tencent-png-clip-art.png"
        alt="rails"
        className={"icon"}
      />
    </li>

    <li>
      <img
        src="https://cdn0.iconfinder.com/data/icons/designer-skills/128/node-js-512.png"
        alt="rails"
        className={"icon"}
      />
    </li>
    <li>
      <a href={props.gitHub || "#"}>
        <img
          src=" https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
          alt="github"
          className={"icon"}
        />
      </a>
    </li>
  </ul>
);
